import { classnames } from '@aibees/shared/utils';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { CreateLabelInputProps as Props } from './types';

export const CreateLabelInput = memo(
  ({ className, isEdit, name, placeholder, ...props }: Props) => {
    return (
      <Styled.Wrapper
        className={classnames('CreateLabelInput', className)}
        sx={SX.root}
        {...props}
        size="small"
        variant="outlined"
        name={name}
        placeholder={!isEdit ? placeholder : undefined}
      />
    );
  }
);

CreateLabelInput.displayName = 'CreateLabelInput';
